//appState
export const ROTATE = "Rotate";

//appHome
export const OPENED_HOME = "OpenedHome";
export const CLICKED_SIGNIN_TOPNAV = "ClickedSigninTopnav";
export const CLICKED_SIGNOUT_TOPNAV = "ClickedSignoutTopnav";
export const CLICKED_REGIONSELECT_TOPNAV = "ClickedRegionselectTopnav";
export const CLICKED_HAMBURGER_HOME = "ClickedHamburgerHome";

//kiosque
export const SWIPED_ARCHIVE_HOME = "SwipedArchiveHome";
export const SWIPED_PROMOSPOT_HOME = "SwipedPromospotHome";
export const SWIPED_SPECIALS_HOME = "SwipedSpecialsHome";
export const CLICKED_ARROW_ARCHIVE_HOME = "ClickedArrowArchiveHome";
export const CLICKED_ARROW_PROMOSPOT_HOME = "ClickedArrowPromospotHome";
export const CLICKED_ARROW_SPECIALS_HOME = "ClickedArrowSpecialsHome";
export const CLICKED_MAIN_HOME = "ClickedMainHome";
export const CLICKED_READ_HOME = "ClickedReadHome";
export const CLICKED_ARCHIVE_HOME = "ClickedArchiveHome";
export const CLICKED_PROMOSPOT_HOME = "ClickedPromospotHome";
export const CLICKED_SPECIALS_HOME = "ClickedSpecialsHome";
export const CLICKED_NEWSSTAND = "ClickedNewsStand";

//region
export const OPENED_REGIONSELECT = "OpenedRegionselect";
export const CLICKED_REGION_REGIONSELECT = "ClickedRegionRegionselect";
export const CLICKED_PROCEED_REGIONSELECT = "ClickedProceedRegionselect";
export const CLICKEDAWAY_REGIONSELECT_TOPNAV = "ClickedAwayRegionSelectTopNav";
export const CLOSED_REGIONSELECT_TOPNAV = "ClosedRegionSelectTopnav";

//readerApp
export const CLICKED_HAMBURGER_READER = "ClickedHamburgerReader";
export const ACCESSED_SOCIALSHARING = "AccessedSocialSharing";

//paywall
export const OPENED_PAYWALL = "OpenedPaywall";
export const FOCUS_USERNAME_PAYWALL = "FocusUsernamePaywall";
export const FOCUS_PASSWORD_PAYWALL = "FocusPasswordPaywall";
export const CLICKED_LOGIN_PAYWALL = "ClickedLoginPaywall";
export const CLICKED_FORGOTPW_PAYWALL = "ClickedForgotpwPaywall";
export const CLOSED_PAYWALL = "ClosePaywall";
export const CLICKED_BACK_PAYWALL = "ClickedBackPaywall";
export const CLICKED_CLOSE_PAYWALL = "ClickedClosePaywall";
export const REACHED_REDIRECT_LIMIT = "ReachedRedirectLimit";
export const PAYWALL_LOGIN_AFTER_SHARE = "PaywallLoginAfterShare";

//error popup

export const OPENED_ERRORPOPUP = "OpenedErrorPopup";
export const CLOSED_ERRORPOPUP = "CloseErrorPopup";
export const CLICKED_BACK_ERRORPOPUP = "ClickedBackErrorPopup";
export const CLICKED_CLOSE_ERRORPOPUP = "ClickedCloseErrorPopup";

//authentication
export const AUTHENTICATED = "Authenticated";
export const AUTHORIZED = "Authorized";

//sidemenu
export const SWIPED_RECENTLY_SIDEBAR = "SwipedRecentlySidebar";
export const SWIPED_SUPPLEMENTS_SIDEBAR = "SwipedSupplementsSidebar";
export const SWIPED_EXTRAS_SIDEBAR = "SwipedExtrasSidebar";
export const CLICKED_HOME_SIDEBAR = "ClickedHomeSidebar";
export const CLICKED_SETTINGS_SIDEBAR = "ClickedSettingsSidebar";
export const SWIPED_CLOSE_SIDEBAR = "SwipedCloseSidebar";
export const OPENED_SIDEBAR = "OpenedSidebar";
export const CLOSED_SIDEBAR = "ClosedSidebar";
export const CLICKED_RECENTLY_SIDEBAR = "ClickedRecentlySidebar";
export const CLICKED_SUPPLEMENTS_SIDEBAR = "ClickedSupplementsSidebar";
export const CLICKED_EXTRAS_SIDEBAR = "ClickedExtrasSidebar";

//settings
export const OPENED_SETTINGS = "OpenedSettings";
export const CLICKED_REGIONSELECT_SETTINGS = "ClickedRegionselectSettings";
export const CLICKED_ACCOUNT_SETTINGS = "ClickedAccountSettings";
export const CLICKED_HELP_SETTINGS = "ClickedHelpSettings";
export const CLICKED_ABOUT_SETTINGS = "ClickedAboutSettings";
export const CLICKED_CLOSE_SETTINGS = "ClickedCloseSettings";
export const CLICKED_LANDSCAPE_TOGGLE_SETTINGS =
  "ClickedLandscapeToggleSettings";

export const OPENED_READING_MODE_SETTINGS = "OpenedReadingModeSettings";
export const CLICKED_BACK_READING_MODE = "ClickedBackReadingMode";
export const CLICKED_CLOSE_READING_MODE = "ClickedCloseReadingMode";

export const OPENED_LANDSCAPE_TOGGLE_SETTINGS = "OpenedLandscapeToggleSettings";
export const CLICKED_BACK_LANDSCAPE_TOGGLE = "ClickedBackLandscapeToggle";
export const CLICKED_CLOSE_LANDSCAPE_TOGGLE = "ClickedCloseLandscapeToggle";
export const CLICKED_DOUBLEPAGE_TOGGLE_SETTINGS =
  "ClickedDoublepageLandscapeToggleSettings";
export const CLICKED_SINGLEPAGE_TOGGLE_SETTINGS =
  "ClickedSinglepageLandscapeToggleSettings";

//regionSetting
export const OPENED_REGIONSELECT_SETTINGS = "OpenedRegionselectSettings";
export const CLICKED_BACK_REGIONSELECT = "ClickedBackRegionselect";
export const CLICKED_CLOSE_REGIONSELECT = "ClickedCloseRegionselect";
//see also event from region

//Accountsettings
export const CLICKED_LOGOUT_SETTINGS = "ClickedLogoutSettings";
//see also events from paywall

//iframe
export const CLICKED_BACK_IFRAME = "ClickedBackIframe";
export const CLICKED_CLOSE_IFRAME = "ClickedCloseIframe";
export const OPENED_IFRAME_SETTINGS = "OpenedIframeSettings";

//about
export const OPENED_ABOUT_SETTINGS = "OpenedAboutSettings";
export const CLICKED_BACK_ABOUT = "ClickedBackAbout";
export const CLICKED_CLOSE_ABOUT = "ClickedCloseAbout";

export const CLICKED_DISCLAIMER_SETTINGS = "ClickedDislaimerSettings";
export const CLICKED_UUID_SETTINGS = "ClickedUuidSettings";
export const CLICKED_EDITOR_SETTINGS = "ClickedEditorSettings";
export const CLICKED_DEVELOPER_SETTINGS = "ClickedDeveloperSettings";

//Viewer
export const OPENED_PUBLICATION_READER = "OpenedPublicationReader";
export const RESIZED_READER = "ResizedReader";
//appReader
export const INIT_READER = "InitReader";

//reader
export const VIEW_PAGE = "ViewPage";
export const VIEW_PAGE_IN_BACKGROUND = "ViewPageInBackground";
export const PERCENTAGE_IN_VIEW_COMPUTED = "PercentageInViewComputed";
export const SWIPE_PAGE_FORWARD_READER = "SwipePageForwardReader";
export const SWIPE_PAGE_BACKWARD_READER = "SwipePageBackwardReader";
export const CLICKED_PAGE_NEXT_READER = "ClickedPageNextReader";
export const CLICKED_PAGE_PREV_READER = "ClickedPagePrevReader";
export const CLICKED_PAGE_NEXT_TOP_READER = "ClickedPageNextTopReader";
export const CLICKED_PAGE_NEXT_BOT_READER = "ClickedPageNextBotReader";
export const CLICKED_PAGE_PREV_TOP_READER = "ClickedPagePrevTopReader";
export const CLICKED_PAGE_PREV_BOT_READER = "ClickedPagePrevBotReader";
export const CLICKED_TOP_NAV_SINGLE_PAGE_MODE = "ClickedTopNavSinglePageMode";
export const CLICKED_TOP_NAV_DOUBLE_PAGE_MODE = "ClickedTopNavDoublePageMode";

//readerSlide
export const ZOOM_PAGE_IN_READER = "ZoomPageInReader";
export const ZOOM_PAGE_OUT_READER = "ZoomPageOutReader";
export const ZOOM_PAGE_IN_READER_ON_DESKTOP = "ZoomPageInReaderOnDesktop";
export const ZOOM_PAGE_OUT_READER_ON_DESKTOP = "ZoomPageOutReaderOnDesktop";
export const PAN_PAGE = "PanPageReader";
export const CLICKED_ZOOM_SLIDER_READER = "ClickedZoomSliderReader";

//reader
export const CLICKED_PAGE_ENRICHMENTBUTTON_READER =
  "ClickedPageEnrichmentbuttonReader";
export const CLICKED_PAGE_ARTICLE_READER = "ClickedPageArticleReader";
export const CLICKED_SUPPLEMENT_READER = "ClickedSupplementReader";

//bottom navigation
export const CLICKED_BOTTOM_NAVIGATION_READER = "ClickedBottomNavigationReader";
export const SWIPED_BOTTOM_NAVIGATION_READER = "SwipedBottomNavigationReader";
export const RELEASE_BOTTOM_NAVIGATION_READER = "ReleaseBottomNavigationReader";
export const CLICKED_FULLSCREEN_READER = "ClickedFullScreenReader";
export const OPENED_FULLSCREEN_READER = "OpenedFullScreenReader";
export const EXIT_FULLSCREEN_READER = "ExitFullScreenReader";
export const CLICKED_ESCAPE_FULLSCREEN_READER =
  "ClickedEscapedFullScreenReader";

//topnavigation
export const OPENED_CATEGORY_DROPDOWN_READER = "OpenedCategoryDropdownReader";
export const CLOSED_CATEGORY_DROPDOWN_READER = "ClosedCategoryDropdownReader";
export const CLICKED_CATEGORY_READER = "ClickedCategoryReader";
export const CLICKED_SUPPLEMENT_TOPNAV_READER = "ClickedSupplementTopnavReader";
export const CLICKED_SUPPLEMENT_BUTTON_READER = "ClickedSupplementButtonReader";
export const CLICKED_BACK_TO_MAIN_READER = "ClickedBackToMainReader";
export const CLICKED_HOME_ICON_READER = "ClickedHomeIconReader";
export const CLICKED_SETTINGS = "ClickedSettings";
export const CLICKED_HELP = "ClickedHelp";
export const CLICKED_FULLPDFDOWNLOAD_READER = "ClickedFullPdfDownload";
export const CLICKED_SINGLEPAGEPDFDOWNLOAD_READER =
  "ClickedSinglePagePdfDownload";

//supplementView
export const OPENED_SUPPLEMENT_SCREEN_READER = "OpenedSupplementScreenReader";
export const CLOSED_SUPPLEMENT_SCREEN_READER = "ClosedSupplementScreenReader";
export const CLICKED_SUPPLEMENT_SUPP_SCREEN = "ClickedSupplementSuppScreen";

//alb controller
export const OPENED_ALB = "OpenedAlb";
export const CLOSED_ALB = "ClosedAlb";
export const CLICKED_BACK_ALB = "ClickedBackAlb";
export const CLICKED_FONT_ALB = "ClickedFontAlb";
export const CLICKED_SHARE_ALB = "ClickedshareAlb";
export const CLICKED_NEXT_ALB = "ClickedNextAlb";
export const CLICKED_PREV_ALB = "ClickedPrevAlb";
export const SWIPED_FORWARD_ALB = "SwipedForwardAlb";
export const SWIPED_BACKWARD_ALB = "SwipedBackwardAlb";
export const VIEW_ARTICLE_ALB = "ViewArticleAlb";
export const CLICKAWAY_OVERLAY_ALB = "ClickedAwayOverlayAlb";
export const CLICKED_ENRICHEMENT_ALB = "ClickedEnrichmentAlb";

//SharingController
export const OPENED_SHARE_MENU_ALB = "OpenedShareMenuAlb";
export const OPENED_SHARE_MENU_NEXTGEN = "OpenedShareMenuNextgen";
export const CLICKED_WHATSAPP_SHARE = "ClickedWhatsappShare";
export const CLICKED_FACEBOOK_SHARE = "ClickedFacebookShare";
export const CLICKED_GOOGLE_SHARE = "ClickedGoogleShare";
export const CLICKED_TWITTER_SHARE = "ClickedTwitterShare";
export const CLICKED_MAIL_SHARE = "ClickedMailShare";
export const CLOSED_SHARE_MENU_ALB = "ClosedShareMenuAlb";

//AlbImageSlider
export const CLICKED_IMAGE_ALB = "ClickedImageAlb";
export const SWIPED_FORWARD_IMAGEVIEWER = "SwipedForwardImageviewer";
export const SWIPED_BACKWARD_IMAGEVIEWER = "SwipedBackwardImageviewer";

//imageviewer
export const OPENED_GALLERY_ALB = "OpenedGalleryAlb";
export const CLOSED_GALLERY_ALB = "ClosedGalleryAlb";
export const SWIPED_FORWARD_GALLERY = "SwipedForwardGallery";
export const SWIPED_BACKWARD_GALLERY = "SwipedBackwardGallery";
export const CLICKED_PREV_GALLERY = "ClickedPrevGallery";
export const CLICKED_NEXT_GALLERY = "ClickedNextGallery";
export const CLICKED_BULLET_GALLERY = "ClickedBulletGallery";
export const VIEW_IMAGE_GALLERY = "ViewImageGallery";

//imageViewerSlide
export const CLICKED_CAPTION_GALLERY = "ClickedCaptionGallery";
export const ZOOM_IN_IMAGE_GALLERY = "ZoomInImageGallery";
export const ZOOM_OUT_IMAGE_GALLERY = "ZoomOutImageGallery";
export const PAN_ZOOMEDINIMAGE_GALLERY = "PanZoomedimageGallery";

//print
export const CLICKED_PRINT_ALB = "ClickedPrintAlb";
export const CLICKED_PRINT_IMAGE_ALB = "ClickedPrintImageAlb";
export const CLICKED_PRINT_TEXT_ALB = "ClickedPrintTextAlb";
export const CLICKED_PRINT_PDF = "ClickedPrintPDF";

//cookie
export const CLICKED_COOKIEACCEPT = "ClickedCookieaccept";

// nextgen
export const VIEW_PAGE_NEXGEN = "NextgenPageView";
export const CLICKED_NEXTGEN_READING_MODE_HOME =
  "ClickedNextgenReadingModeHome";
export const CLICKED_REPLICA_READING_MODE_HOME =
  "ClickedReplicaReadingModeHome";
export const CLICKED_NEXTGEN_READING_MODE_SIDEBAR =
  "ClickedNextgenReadingModeSidebar";
export const CLICKED_REPLICA_READING_MODE_SIDEBAR =
  "ClickedReplicaReadingModeSidebar";
export const CLICKED_REPLICA_READING_MODE_READER =
  "ClickedReplicaReadingModeReader";
export const CLICKED_NEXTGEN_READING_MODE_READER =
  "ClickedNextgenReadingModeReader";
export const CLICKED_READING_MODE_SETTINGS = "ClickedReadingModeSettings";
export const CLICKED_NEXTGEN_READING_MODE_SETTINGS =
  "ClickedNextgenReadingModeSettings";
export const CLICKED_REPLICA_READING_MODE_SETTINGS =
  "ClickedReplicaReadingModeSettings";
export const VIEW_ARTICLE_ALB_NEXTGEN = "ViewArticleAlbNextgen";

export const CLICKED_PRINT_READER = "clickedPrintReader";
export const ADJUSTED_BOX_CROPPING = "adjustedBoxCropping";
export const CLICKED_PRINT_CROPPING = "clickedPrintCropping";



// WEBPACK FOOTER //
// ./src/common/analytics/analyticsevents.js